'use client'

import { states } from '@/lib/states'
import { getStateOptions } from '@/modules/salary/filters/utils'

export function useStateSearch() {
  const searchState = async (inputValue: string) => {
    return getStateOptions(
      states
        .filter((state: { name: string; code: string }) => {
          return (
            state.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            state.code.toLowerCase().includes(inputValue.toLowerCase())
          )
        })
        .sort((a, b) => {
          // if an exact match is found, sort it to the top
          const inputValueLower = inputValue.toLowerCase()
          if (
            a.name.toLowerCase() === inputValueLower ||
            b.name.toLowerCase() === inputValueLower ||
            a.code.toLowerCase() === inputValueLower ||
            b.code.toLowerCase() === inputValueLower
          ) {
            return -1
          }
          return 0
        }),
    )
  }

  return {
    searchState,
    states,
  }
}
